module.exports = __webpack_public_path__ + "img/article.eab03836.svg";